import {Dialog} from '@capacitor/dialog';
import {Component} from "@angular/core";
import {Loading, LoadingController, ModalController, NavController, NavParams} from "ionic-angular";
import {Cart} from "../../app/classes/cart";
import {CartService} from "../../app/services/cart.service";
import {UserService} from "../../app/services/user.service";
import {UserAddress} from "../../app/classes/user_address";
import {AddressPage} from "../address/address";
import {
  USER_ACCOUNT_STORAGE,
  USER_PREFERRED_ADDRESS_STORAGE,
  USER_PREFERRED_DELIVERY_STORAGE,
  USER_SECRET_STORAGE
} from "../../app/constants/storage";
import {ORDER_TYPES} from "../../app/constants/config";
import {Headers, Http, RequestOptions} from "@angular/http";
import {API} from "../../app/services/api.service";
import {Customer, IOrderTypesPayload} from "../../app/classes/customer";
import {MinimumOrderValue} from "../../app/classes/minimum_order_value";
//import {OrderSubmitPage} from "../order-submit/order-submit";
import {OrderSummaryPage} from "../order-summary/order-summary"
import {Address} from "../../app/classes/address";
import {EmptyAddress} from "../../app/classes/empty_address";
import {AnalyticsService} from "../../app/services/analytics.service";
import {RegisterPage} from "../register/register";
import {TabsPage} from "../tabs/tabs";
import {FormBuilder, Validators} from "@angular/forms";
import {POSTAL_CODE_LENGTH} from "../../app/constants/numbers";
import {IAddress} from "../../app/interfaces/address";
import {getPlacePredictions} from "../../app/utils";
import {StorageService} from "../../app/services/storage.service";
import {isArray} from "rxjs/util/isArray";
import {OrderSubmitPage} from "../order-submit/order-submit";

declare const google: any;

/**
 * Default address form validations
 * @type {ValidatorFn}
 */
const DEFAULT_FORM_VALIDATE = Validators.compose([
  Validators.required
]);

/**
 * Form validations for postalcodes
 * @type {ValidatorFn}
 */
const POSTALCODE_FORM_VALIDATE = Validators.compose([
  Validators.required,
  Validators.pattern('[0-9]*'),
  Validators.maxLength(POSTAL_CODE_LENGTH),
  Validators.minLength(POSTAL_CODE_LENGTH)
]);

@Component({
  selector: 'page-checkout',
  templateUrl: 'checkout.html',
  providers: [
    CartService, UserService]
})
export class CheckoutPage {
  public cart: Cart;
  public customer: Customer;
  public delivery;
  public places: string;
  public shippingAddress?: Address;
  public canRedeemCoupons: boolean = false;
  public message: string;
  public couponsRedeemed: boolean = false;
  public addMessage: boolean = false;
  public openingTimeInterval: any;
  public isOrdering : boolean = false;
  public isOpen: boolean = true;
  public deliveryAvail: boolean = true;
  public addressTimer;
  public addressLoading = false;
  public autocompleteResults = [];
  public addressForm;
  public saveAddress: boolean;
  public paymentMethod: string = "cash";
  public service = new google.maps.places.AutocompleteService();
  public shippingConstraint = {
    matchID: false,
    hasError: false,
    error: null,
    valid: false,
    invalid: true,
    required: 0,
    firstname: false,
    lastname: false,
    unknown: true,
    address: false,
    cost: 0,
    postalcode: null,
    location: null,
    sublocation: null,
    street: null,
    minimumCartPrice: 0,
  };

  constructor(public formBuilder: FormBuilder, public loadingCtrl: LoadingController, private analytics: AnalyticsService, public storage: StorageService, public userService: UserService, private api: API, public http: Http, public cartService: CartService, public modalCtrl: ModalController, public navCtrl: NavController, public navParams: NavParams) {
    this.cart = cartService.getCart();

    this.init();
  }

  async init() {
    const result: any = await this.storage.get(USER_PREFERRED_ADDRESS_STORAGE);
    if (result) {
      this.shippingAddress = new UserAddress(result.address) as Address;
      console.info("Got shipping address", result.address);
    }

    if (!this.shippingAddress) {
      this.shippingAddress = new EmptyAddress({});
    }

    this.addressForm = this.formBuilder.group({
      "address": this.shippingAddress.street ? `${this.shippingAddress.street || ""} ${this.shippingAddress.streetnumber || ""}, ${this.shippingAddress.postalcode || ""} ${this.shippingAddress.location || ""}` : "",
      firstname: [this.shippingAddress.firstname || '', DEFAULT_FORM_VALIDATE],
      lastname: [this.shippingAddress.lastname || '', DEFAULT_FORM_VALIDATE],
      postalcode: [this.shippingAddress.postalcode || '', POSTALCODE_FORM_VALIDATE],
      street: [this.shippingAddress.street || '', DEFAULT_FORM_VALIDATE],
      streetnumber: [this.shippingAddress.streetnumber || '', DEFAULT_FORM_VALIDATE],
      location: [this.shippingAddress.location || '', DEFAULT_FORM_VALIDATE],
      political: [this.shippingAddress.political || ''],
      sublocality: [this.shippingAddress.sublocality || ''],

      floor: [this.shippingAddress.floor || ""],
      identifier: [this.shippingAddress.identifier || ''],
      lat: [this.shippingAddress.lat || ''],
      lng: [this.shippingAddress.lng || ''],
    });

    this.customer = Customer.cachedOrCreate(this.http) as Customer;
  }

  ionViewWillEnter() {
    this.customer = Customer.cachedOrCreate(this.http) as Customer;
    this.init();
    //this.analytics.trackView("Cart");
    this.openingTimeInterval = setInterval(() => {
      this.checkOpeningTimes();
    }, 10000);
    this.checkOpeningTimes();

    this.movInterval = setInterval(() => {
      this.updateShippingConstraint();
    }, 1000);
    this.updateShippingConstraint();
    this.getOrderTypes();
  }

  async resolveAddress(prediction) {
    console.log('PREDICTION', prediction);
    this.loader = this.loadingCtrl.create({
      content: "Adresse wird geladen...",
    });
    try {
      await this.loader.present();
      const address: any = await UserAddress.fromPrediction(this.http, prediction);
      console.log("ADDRESS", address);
      this.addressForm.setValue({
        "address": `${address.street || ""} ${address.streetnumber || ""}, ${address.postalcode || ""} ${address.location || ""}`,
        "street": address.street,
        "location": address.location,
        "postalcode": address.postalcode,
        "streetnumber": address.streetnumber,
        "firstname": this.addressForm.get("firstname").value,
        "lastname": this.addressForm.get("lastname").value,
        political: address.political || "",
        sublocality: address.sublocality || "",
        "lat": address.lat,
        "lng": address.lng,
        "floor": this.addressForm.get("floor").value,
        "identifier": ""
      });
    } catch (e) {
      console.log(e);
    } finally {
      this.hideLoader();
      this.autocompleteResults = [];
    }
  }

  async searchPlaces() {
    if (!this.service) {
      return;
    }

    if (this.addressTimer) {
      clearTimeout(this.addressTimer)
    }

    this.addressTimer = setTimeout(async () => {
      try {
        this.addressLoading = true;
        this.autocompleteResults = await getPlacePredictions(this.service, this.places);
        this.autocompleteResults = this.autocompleteResults.map((res) => {
          return {...res, description: res.description.replace(/\, Deutschland/, "")}
        })
      } catch (error) {
        this.shippingConstraint = {
          ...this.shippingConstraint,
          hasError: true,
          error
        }
      } finally {
        this.addressLoading = false;
      }
    }, 300);
  }

  public movInterval;

  ionViewWillLeave() {
    clearInterval(this.openingTimeInterval);
    clearInterval(this.movInterval);
  }

  checkOpeningTimes() {
    this.api.isOpen().subscribe(
      result => {
        this.isOpen = result.opened;
        this.deliveryAvail = result.delivery;
      },
      error => () => {
        this.isOpen = false;
      }
    );
  }

  getOrderTypes(){

    if(!this.deliveryAvail){
      let test = this.customer.orderTypes;
      return  test.filter((obj) => obj.requires_mov !== 1 );
    }

    return this.customer.orderTypes;
  }

  updateShippingConstraint() {
    if (!this.delivery) {
      this.shippingConstraint = {...this.shippingConstraint, hasError: false, error: null};
      return;
    }

    const resolvedDelivery = ORDER_TYPES.filter((orderType) => orderType.id === this.delivery)[0];


    try {
      const {matchID, valid, unknown, invalid, location, sublocation, postalcode, minimumCartPrice, cost} = MinimumOrderValue.get(this.customer.minimumOrderValues, this.addressForm.value, this.cart.getGrandTotal());
      this.shippingConstraint = {
        ...this.shippingConstraint,
        matchID,
        firstname: this.addressForm.value.firstname,
        lastname: this.addressForm.value.lastname,
        required: resolvedDelivery.requires_mov,
        valid: !resolvedDelivery.requires_mov || valid,
        unknown: unknown,
        invalid: invalid,
        location,
        sublocation,
        hasError: false,
        error: null,
        postalcode,
        minimumCartPrice,
        cost
      };
    } catch (error) {
      // TODO: specify exception
      this.shippingConstraint = {
        ...this.shippingConstraint,
        hasError: true,
        error
      }
    }
  }

  redeemCoupons() {
    this.couponsRedeemed = true;
  }

  unredeemCoupon() {
    this.couponsRedeemed = false;
  }

  public loader: Loading;

  async sendOrder() {
    if (this.isOrdering){
      return;
    }

    this.loader = this.loadingCtrl.create({
      content: "Lade..."
    });
    try {
      this.isOrdering = true;
      await this.loader.present();

      if (!this.delivery) {
        Dialog.alert({title:null,message :'Bitte wähle aus ob du die Bestellung selbst abholen oder geliefert bekommen möchtest'})
          .then(() => console.log('Dialog dismissed'))
          .catch(e => console.log('Error displaying dialog', e));
        this.hideLoader();
        return;
      }

      if (!this.isOpen) {
        Dialog.alert({title:null,message:'Wir haben leider geschlossen, versuche es später noch einmal.'})
          .then(() => console.log('Dialog dismissed'))
          .catch(e => console.log('Error displaying dialog', e));
        this.hideLoader();
        return;
      }

      let headers = new Headers();
      const credentials = await this.storage.get(USER_SECRET_STORAGE);
      if (credentials && credentials.verified) {
        headers.append("X-USER-SECRET", credentials.secret);
        headers.append("X-USER-PHONENUMBER", credentials.phonenumber);
      }

      const orderPayload = this.cart.getOrderPayload();
      this.addressForm.identifier = +new Date();
      if (this.shippingConstraint.valid) {
        const userAddress: UserAddress = new UserAddress(this.addressForm.value as IAddress);

        orderPayload.shippingAddress = userAddress.serialize();
        orderPayload.paymentMethod = this.paymentMethod;
        orderPayload.paymentIntent = "AUTHORIZE";
        orderPayload.mov = this.shippingConstraint.matchID;
        orderPayload.orderType = this.delivery;
        orderPayload.message = this.message || "";


        const options = new RequestOptions({headers});
        this.http.post(`
      ${API.BASE_HOST}/customers/${API.CUSTOMER}/orders/
    `, orderPayload, options).subscribe(
          result => this.handleResult(result),
          err => this.handleError(err)
        );
      } else {
        Dialog.alert({message:"Bitte gebe deine vollständige Adresse an.", title:"Da fehlt noch etwas"});
      }
    } catch (e) {
      console.log(e);
      Dialog.alert({title:null,message:"Deine Bestellung konnte nicht abgeschickt werden, bitte versuche es erneut."});
    } finally {
      this.isOrdering = false;
    }
  }

  private hideLoader() {
    if (this.loader)
      this.loader.dismiss();
  }

  handleResult(order) {
    this.hideLoader();
    const data = order.json();
    if (data.status !== "open") {
      return;
    }

    const modal = this.modalCtrl.create(OrderSubmitPage, {order: data});
    modal.present();
    modal.onDidDismiss((success) => {
      //  this.navCtrl.setRoot(MenuPage);
      if (!success) {
        Dialog.alert({
          message:"Bestellung konnte nicht übertragen werden, bitte versuche es später noch einmal.",
          title:"Fehler beim Abrufen"
        });
      } else {
        this.cartService.getCart().clear();
        this.navCtrl.setRoot(TabsPage);

        this.analytics.trackView("Order Successful");
      }
    });

    if (order.json().error_code === 2000) {
      this.navCtrl.push(RegisterPage);
      this.storage.set(USER_ACCOUNT_STORAGE, {});
    }
  }

  handleError(err) {
    console.log(err);
    this.hideLoader();
    Dialog.alert({message:"Fehler beim Übertragen der Bestellungen, bitte versuchen Sie es später noch einmal.", title:"Fehler"});
  }

  savePreferredDeliveryMethod() {
    this.updateShippingConstraint();
    this.storage.set(USER_PREFERRED_DELIVERY_STORAGE, this.delivery);
  }

  selectShippingAddress() {
    const modal = this.modalCtrl.create(AddressPage, {'mode': 'select'});
    modal.onDidDismiss((result) => {
      if (!result) {
        return;
      }
      this.shippingAddress = new UserAddress(result.address) as Address;
      this.storage.set(USER_PREFERRED_ADDRESS_STORAGE, {
        address: this.shippingAddress
      });
      this.addressForm.setValue({
        "address": `${this.shippingAddress.street || ""} ${this.shippingAddress.streetnumber || ""}, ${this.shippingAddress.postalcode || ""} ${this.shippingAddress.location || ""}`,
        "street": this.shippingAddress.street,
        "location": this.shippingAddress.location,
        "postalcode": this.shippingAddress.postalcode,
        "streetnumber": this.shippingAddress.streetnumber || "",
        "firstname": this.shippingAddress.firstname,
        "lastname": this.shippingAddress.lastname,
        "floor": this.shippingAddress.floor ||"EG",
        "sublocality": this.shippingAddress.sublocality,
        "political": this.shippingAddress.political ?? "none",
        "identifier": "",
        "lat": this.shippingAddress.lat,
        "lng": this.shippingAddress.lng
      });
    });
    this.updateShippingConstraint();
    modal.present();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad CheckoutPage');
  }

  toSummary(){
    this.hideLoader();
    console.log(this.delivery)

    const modal = this.modalCtrl.create(OrderSummaryPage,{deliver:this.delivery,cart:this.cart,customer:this.customer,address: new UserAddress(this.addressForm.value as IAddress).serialize()});
    modal.present();
    modal.onDidDismiss((success) => {
      if(success)this.sendOrder()
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/checkout/checkout.ts